import React, { createContext, useState, useContext, useEffect } from "react";

// Create the context
const DataContext = createContext();

// Create a custom hook to use the DataContext
export const useDataContext = () => useContext(DataContext);

// Provider Component
export const DataProvider = ({ children }) => {
  const [modules, setModules] = useState([]); // Initialize with an empty array or any default value
const [role,setRole]=useState("")
  // Function to update the data array
  const updateModules = (newData) => {
    setModules(newData);
  };
  const Role = (newData) => {
    setRole(newData);
  };

  

  return (
    <DataContext.Provider value={{ modules, updateModules,role,setRole }}>
      {children}
    </DataContext.Provider>
  );
};
